import React from "react";
import {
  Form,
  GroupItem,
  Item,
  RequiredRule,
  RangeRule,
  CustomRule,
  Label,
} from "devextreme-react/form";

const dateMin = new Date(Date.now() - 24 * 60 * 60 * 1000),
  descriptionOptions = {
    height: 90,
  },
  dateOptions = {
    width: "100%",
    type: "date",
    displayFormat: "shortdate",
    showClearButton: true,
    placeholder: "mm/dd/yyyy",
  },
  startTimeData = [
    { id: 7, display: "7:00 am" },
    { id: 8, display: "8:00 am" },
    { id: 9, display: "9:00 am" },
    { id: 10, display: "10:00 am" },
    { id: 11, display: "11:00 am" },
    { id: 12, display: "12:00 pm" },
    { id: 13, display: "1:00 pm" },
    { id: 14, display: "2:00 pm" },
    { id: 15, display: "3:00 pm" },
    { id: 16, display: "4:00 pm" },
    { id: 17, display: "5:00 pm" },
  ],
  endTimeData = [
    { id: 8, display: "8:00 am" },
    { id: 9, display: "9:00 am" },
    { id: 10, display: "10:00 am" },
    { id: 11, display: "11:00 am" },
    { id: 12, display: "12:00 pm" },
    { id: 13, display: "1:00 pm" },
    { id: 14, display: "2:00 pm" },
    { id: 15, display: "3:00 pm" },
    { id: 16, display: "4:00 pm" },
    { id: 17, display: "5:00 pm" },
    { id: 18, display: "6:00 pm" },
  ],
  requestStartTimeOptions = {
    items: startTimeData,
    valueExpr: "id",
    displayExpr: "display",
  },
  requestEndTimeOptions = {
    items: endTimeData,
    valueExpr: "id",
    displayExpr: "display",
  };

const RequestTimeOffForm = ({
  formData,
  formRef,
  formFieldDataChanged,
  dateCheck,
}) => {
  const validateTime = (e) => {
    const { startDate, endDate, startTime } = formData;
    const endTime = e.value;

    if (!startDate || !endDate || !startTime || !endTime) {
      return true; // Skip validation if any value is missing
    }
    if (new Date(startDate).getTime() === new Date(endDate).getTime()) {
      return startTime < endTime; // Ensure start time is before end time
    }
    return true; // No validation needed if dates are different
  };

  return (
    <Form
      formData={formData}
      ref={formRef}
      onFieldDataChanged={formFieldDataChanged}
      showValidationSummary={true}
    >
      <GroupItem colCount={2}>
        <GroupItem colSpan={2} colCount={2}>
          <Item
            dataField="startDate"
            editorType="dxDateBox"
            editorOptions={dateOptions}
            isRequired={true}
            colSpan={1}
          >
            <RequiredRule message="Date is required" />
            <RangeRule
              min={dateMin}
              message="Can not add request for past dates"
            />
          </Item>
          <Item
            dataField="endDate"
            editorType="dxDateBox"
            editorOptions={dateOptions}
            isRequired={true}
            colSpan={1}
          >
            <RequiredRule message="Date is required" />
            <RangeRule
              min={dateCheck}
              message="End date must be after start date"
            />
          </Item>
          <GroupItem colSpan={2} colCount={2}>
            <Item
              isRequired={true}
              dataField="startTime"
              editorType="dxSelectBox"
              editorOptions={requestStartTimeOptions}
              colSpan={1}
            ></Item>
            <Item
              isRequired={true}
              dataField="endTime"
              editorType="dxSelectBox"
              editorOptions={requestEndTimeOptions}
              colSpan={1}
            >
              <CustomRule
                message="End time must be after start time"
                validationCallback={validateTime}
              />
            </Item>
          </GroupItem>
        </GroupItem>
        <Item
          dataField="description"
          editorType="dxTextArea"
          editorOptions={descriptionOptions}
          colSpan={2}
        >
          <Label text={"Reason"} />
        </Item>
      </GroupItem>
    </Form>
  );
};

export default RequestTimeOffForm;
